module.exports = require("@swa-ui/geolocation");